import React, {useState} from 'react';
import { Col, Row,Image } from 'antd';
import {useSelector} from "react-redux";
import '../index.css'


const AnalysisAnswer = (props) =>  {

    const {answer,sendTxt,setSendTxt,analysisMeta,ti,svgIndex,setSvgIndex} = props
    const data = answer?.content;
    const {size} = useSelector(state => state.fontSizeChange)
    const answerThree = {
        fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
        paddingTop:'5px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        lineHeight:'25px'
    }
    const analysis_meta = analysisMeta
    const handleSvgNext = (list) => {
        let i = ti;
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        if (index[i] >= (svgList.length - 1)) {
            index[i] = 0
            setSvgIndex([...index])
            return svgList[0]
        }
        index[i] = index[i] + 1
        setSvgIndex([...index])
        return svgList[index[i]]
    }
    const handleSvgPrev = (list) => {
        let i = ti;
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        if (index[i] === 0) {
            index[i] = (svgList.length - 1)
            setSvgIndex([...index])
            return svgList[index[i]]
        }
        index[i] = index[i] - 1
        setSvgIndex([...index])
        return svgList[index[i]]
    }
    const getAnswerSvg = (list) => {
        let i = ti;
        let svgList = analysis_meta.responder === '灵问语法分析模型-v1-中文标签' ? list.gbw_svg_zh_ls : list.gbw_svg_en_ls,
            index = svgIndex;
        return svgList[index[i]]
    }
    return (
        <div>
            <div className={'answerFx'}>
                <div><Image
                    onClick={() => handleSvgNext(answer?.responder_content[0].content.gbw_of_sentences[0])}
                    alt={'下一张'}
                    src={require('../../../../assets/comm/ai-chat-big.png')}
                    width={20} preview={false}></Image></div>
                <div><Image
                    onClick={() => handleSvgPrev(answer?.responder_content[0].content.gbw_of_sentences[0])}
                    alt={'上一张'}
                    src={require('../../../../assets/comm/ai-chat-small.png')}
                    width={20} preview={false}></Image></div>
            </div>
            <div className="answerSvg"
                 dangerouslySetInnerHTML={{__html: getAnswerSvg(answer?.responder_content[0].content.gbw_of_sentences[0])}}/>
        </div>
    );
}


export default AnalysisAnswer

